module.exports = __webpack_public_path__ + "img/orelsan.6650cf12.jpg";